import { combineReducers } from 'redux'

import { authentication } from './authentication.reducer'
import { registration } from './registration.reducer'
import { users } from './users.reducer'
import { alert } from './alert.reducer'
import { sector } from './sector.reducer'
import { company } from './company.reducer'
import { lookup } from './lookup.reducer'
import { industry } from './industry.reducer'
import { exchange } from './exchange.reducer'
import { castle } from './castle.reducer'
import { mapkeys } from './mapkeys.reducer'
import { role } from './role.reducer'
import { audits } from './audit.reducer'
import {content} from './content.reducer'
const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  sector,
  company,
  lookup,
  exchange,
  industry,
  castle,
  mapkeys,
  role,
  audits,
  content,
 })

export default rootReducer
